import React from 'react';
import { Globe, Zap, Lock, Headphones } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';

const AboutSection = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const features = [
    {
      icon: Globe,
      title: t.globalCoverage,
      description: t.globalCoverageDesc,
      bgColor: 'bg-orange-100',
      iconColor: 'text-orange-500'
    },
    {
      icon: Zap,
      title: t.quickAlerts,
      description: t.quickAlertsDesc,
      bgColor: 'bg-purple-100',
      iconColor: 'text-purple-500'
    },
    {
      icon: Lock,
      title: t.exclusiveDeals,
      description: t.exclusiveDealsDesc,
      bgColor: 'bg-orange-100',
      iconColor: 'text-orange-500'
    },
    {
      icon: Headphones,
      title: t.personalSupport,
      description: t.personalSupportDesc,
      bgColor: 'bg-purple-100',
      iconColor: 'text-purple-500'
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-16">{t.aboutMe}</h2>
        
        <div className="flex flex-col md:flex-row items-center gap-12">
          <div className="md:w-1/3 flex justify-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_nozhatrips/artifacts/3owatct6_Nuzha%20Trips.jpg" 
              alt="NozhaTrips Logo" 
              className="w-64 h-64 object-contain"
            />
          </div>
          
          <div className="md:w-2/3">
            <p className="text-lg mb-8 text-gray-700 leading-relaxed">
              {t.aboutDescription}
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {features.map((feature, index) => {
                const Icon = feature.icon;
                return (
                  <div key={index} className="flex items-start gap-4">
                    <div className={`${feature.bgColor} p-3 rounded-full flex-shrink-0`}>
                      <Icon className={`${feature.iconColor} w-6 h-6`} />
                    </div>
                    <div>
                      <h3 className="font-bold text-lg mb-1">{feature.title}</h3>
                      <p className="text-gray-600">{feature.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
